import React from 'react'
import { hasErrors } from './'
import Icon from 'src/components/Icon'
import FormError from './FormError'

const SelectField = ({ field, form, ...props }) => {
  return (
    <div className="mb-6">
      <div className="relative">
        <select
          {...field}
          {...props}
          className={`block appearance-none w-full rounded-lg py-4 px-6 text-lg bg-primary-lighter ${
            hasErrors({ field, form })
              ? 'border border-error'
              : 'border border-transparent'
          }`}
        >
          {props.children}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center text-gray-700 pointer-events-none">
          <Icon icon="selectArrows" className="w-5 h-5 fill-current" />
        </div>
      </div>
      {form &&
        Object.entries(form).length > 0 &&
        form.errors[field.name] &&
        form.submitCount > 0 && <FormError error={form.errors[field.name]} />}
    </div>
  )
}

export default SelectField
